import React from 'react';

import { Formatters, Messages } from '../../../../../gen-src/Localize';

import {
  dataDetailsContentWidth,
  DatasourceListBody,
  DatasourceListSection,
  DatasourcesSectionHeader
} from './ViewerPaneStyles';
import { VizClientDatasourceElement } from './VizClientDatasourceElement';
import { VizClientDatasource } from './VizClientInterfaces';

const datasourceListMaxHeight = 200;

export const datasourceListSectionTestId = 'data-details-datasource-list-section';
export const datasourceListHeaderTestId = 'data-details-datasources-with-count-header';

export interface VizClientDatasourceListProps {
  readonly datasources: ReadonlyArray<VizClientDatasource>;
  readonly workbookVizportalUrlId: string;
}

/** A widget to display a list of datasources associated with the current sheet */
export function VizClientDatasourceList(props: VizClientDatasourceListProps) {
  const shouldHaveMaxHeightOnDatasourceList = props.datasources.length > 2;
  return (
    <DatasourceListSection data-tb-test-id={datasourceListSectionTestId}>
      <DatasourcesSectionHeader data-tb-test-id={datasourceListHeaderTestId}>
        {Messages.DatasourcesWithCount({ count: Formatters.formatCount(props.datasources.length) })}
      </DatasourcesSectionHeader>
      <DatasourceListBody
        style={shouldHaveMaxHeightOnDatasourceList ?
          { maxHeight: datasourceListMaxHeight, overflow: 'visible' } :
          { width: dataDetailsContentWidth, overflow: 'visible' }}
        data-tb-test-id='data-details-datasource-list-body'
      >
        {props.datasources.map((datasource) =>
          <VizClientDatasourceElement
            key={datasource.id}
            datasource={datasource}
            workbookVizportalUrlId={props.workbookVizportalUrlId}
          />
        )}
      </DatasourceListBody>
    </DatasourceListSection>
  );
}
